import { render, staticRenderFns } from "./taskToDelegate.vue?vue&type=template&id=43095529&scoped=true&"
import script from "./taskToDelegate.vue?vue&type=script&lang=js&"
export * from "./taskToDelegate.vue?vue&type=script&lang=js&"
import style0 from "./taskToDelegate.vue?vue&type=style&index=0&id=43095529&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43095529",
  null
  
)

export default component.exports